import { BehaviorParameters } from 'rangeConfig/@types';

const replaceShelfAndOrganizer = ({ coreApi, props, rootState }: BehaviorParameters) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();
  if (!selectedEntity) {
    return;
  }
  const newProductType =
    rootState.products.inMarket.find(p => p.coreProductId === props.coreProductId)?.type || '';
  const oldProductType = coreApi.entities.getProductType(selectedEntity) || '';

  if (newProductType === oldProductType) {
    const replacePlacementResult = coreApi.products.replace(selectedEntity.id, props.coreProductId);

    if (
      replacePlacementResult?.replacedEntityResult.valid &&
      replacePlacementResult.replacedEntityResult.placedEntity
    ) {
      replacePlacementResult?.childrenResult.every(item => {
        if (!item.valid) {
          item.placedEntity && coreApi.entities.delete(item.placedEntity);
        }
      });
      coreApi.entities.select(replacePlacementResult.replacedEntityResult.placedEntity);
    } else {
      coreApi.history.undo();
      coreApi.history.discardLatestSnapshot();
    }
  } else {
    const replacePlacementResult = coreApi.products.replace(selectedEntity.id, props.coreProductId);

    if (
      replacePlacementResult?.replacedEntityResult.valid &&
      replacePlacementResult.replacedEntityResult.placedEntity
    ) {
      coreApi.entities.select(replacePlacementResult.replacedEntityResult.placedEntity);
    }
  }
};

export default replaceShelfAndOrganizer;
